import { motion } from 'framer-motion'
import { useChat } from '@/contexts/ChatContext'
import { Button } from './ui/Button'
import { clsx } from 'clsx'

export function QuickReplies() {
  const { quickReplies, sendMessage, requestEscalation } = useChat()

  const handleQuickReply = (reply: typeof quickReplies[0]) => {
    if (reply.action === 'escalate') {
      requestEscalation('User selected escalation option')
    } else if (reply.action === 'handoff') {
      // Handle handoff action
      requestEscalation('User requested handoff to human agent')
    } else {
      sendMessage(reply.text)
    }
  }

  if (quickReplies.length === 0) return null

  return (
    <div className="p-4">
      <div className="mb-2">
        <span className="text-xs font-medium text-slate-600 dark:text-slate-300 outdoor-contrast">
          Quick replies:
        </span>
      </div>
      
      <div className="flex flex-wrap gap-2">
        {quickReplies.map((reply, index) => (
          <motion.div
            key={reply.id}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              delay: index * 0.1,
              type: 'spring',
              stiffness: 300,
              damping: 25
            }}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <Button
              variant="outline"
              size="sm"
              onClick={() => handleQuickReply(reply)}
              className={clsx(
                'text-sm font-medium transition-all duration-200',
                'bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm',
                'border-slate-300 dark:border-slate-600',
                'hover:bg-carnival-50 dark:hover:bg-carnival-900/20',
                'hover:border-carnival-300 dark:hover:border-carnival-600',
                'text-slate-700 dark:text-slate-200',
                'focus-visible shadow-outdoor-sm',
                {
                  'border-orange-300 text-orange-700 hover:bg-orange-50 dark:border-orange-600 dark:text-orange-300 dark:hover:bg-orange-900/20': 
                    reply.action === 'escalate' || reply.action === 'handoff'
                }
              )}
            >
              {reply.text}
            </Button>
          </motion.div>
        ))}
      </div>

      {/* Category indicator if available */}
      {quickReplies.some(reply => reply.category) && (
        <div className="mt-2 flex items-center space-x-2">
          {Array.from(new Set(quickReplies.map(r => r.category).filter(Boolean))).map(category => (
            <span 
              key={category}
              className="text-xs px-2 py-1 bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 rounded-full"
            >
              {category}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}